// @flow
import { shouldUseMockApi } from '../library/settings/environmentSettings';
import { HitchpinMockApi } from './HitchpinMockApi';
import * as auth from './endpoints/auth';
import * as agreements from './endpoints/agreements';
import * as attachments from './endpoints/attachments';
import * as bookmarks from './endpoints/bookmarks';
import * as builds from './endpoints/builds';
import * as cards from './endpoints/cards';
import * as cardsV2 from './endpoints/cardsV2';
import * as categories from './endpoints/categories';
import * as categorySummary from './endpoints/categorySummary';
import * as chats from './endpoints/chats';
import * as chatMessages from './endpoints/chatMessages';
import * as chatUsers from './endpoints/chatUsers';
import * as clientVersion from './endpoints/clientVersion';
import * as commerce from './endpoints/commerce';
import * as contact from './endpoints/contact';
import * as contestSubmissions from './endpoints/contestSubmissions';
import * as couponFavorites from './endpoints/couponFavorites';
import * as coupons from './endpoints/coupons';
import * as device from './endpoints/device';
import * as geoip from './endpoints/geoip';
import * as icons from './endpoints/icons';
import * as invoices from './endpoints/invoices';
import * as lands from './endpoints/lands';
import * as myOfferings from './endpoints/myOfferings';
import * as myWanteds from './endpoints/myWanteds';
import * as notifications from './endpoints/notifications';
import * as offeringImages from './endpoints/offeringImages';
import * as offeringVideos from './endpoints/offeringVideos';
import * as offerings from './endpoints/offerings';
import * as offeringReviews from './endpoints/offeringReviews';
import * as paymentMethods from './endpoints/paymentMethods';
import * as profile from './endpoints/profile';
import * as promoted from './endpoints/promoted';
import * as purchases from './endpoints/purchases';
import * as purchaseSchema from './endpoints/purchaseSchema';
import * as purchaseTickets from './endpoints/purchaseTickets';
import * as purchaseLands from './endpoints/purchaseLands';
import * as questions from './endpoints/questions';
import * as reviews from './endpoints/reviews';
import * as reviewDimensions from './endpoints/reviewDimensions';
import * as reviewStars from './endpoints/reviewStars';
import * as sales from './endpoints/sales';
import * as saleLands from './endpoints/saleLands';
import * as saleSchema from './endpoints/salesSchema';
import * as saleReviews from './endpoints/saleReviews';
import * as saleTickets from './endpoints/saleTickets';
import * as searchAlert from './endpoints/searchAlert';
import * as storefronts from './endpoints/storefronts';
import * as supplyProposals from './endpoints/supplyProposals';
import * as userAddresses from './endpoints/userAddresses';
import * as wallet from './endpoints/wallet';
import * as waivers from './endpoints/waivers';
import * as wanteds from './endpoints/wanteds';

export const HitchpinApi = shouldUseMockApi()
  ? HitchpinMockApi
  : {
      auth,
      agreements,
      attachments,
      bookmarks,
      builds,
      cards,
      cardsV2,
      categories,
      categorySummary,
      chats,
      chatMessages,
      chatUsers,
      clientVersion,
      commerce,
      contact,
      contestSubmissions,
      couponFavorites,
      coupons,
      device,
      geoip,
      icons,
      invoices,
      lands,
      myOfferings,
      myWanteds,
      notifications,
      offeringImages,
      offeringVideos,
      offerings,
      offeringReviews,
      paymentMethods,
      profile,
      promoted,
      purchases,
      purchaseSchema,
      purchaseTickets,
      purchaseLands,
      questions,
      reviews,
      reviewDimensions,
      reviewStars,
      sales,
      saleLands,
      saleReviews,
      saleSchema,
      saleTickets,
      searchAlert,
      storefronts,
      supplyProposals,
      userAddresses,
      wallet,
      waivers,
      wanteds,
    };
